import React from 'react';
import './Input.css';

/**
 * Input component for form fields
 * 
 * @param {string} type - Input type: 'text', 'email', 'password', 'number', etc.
 * @param {string} label - Label text for the input
 * @param {string} placeholder - Placeholder text
 * @param {string} error - Error message to display
 * @param {boolean} required - Whether the field is required
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional props to pass to the input element
 */
const Input = ({
  type = 'text',
  label,
  placeholder,
  error,
  required = false,
  className = '',
  ...props
}) => {
  const inputId = props.id || `input-${Math.random().toString(36).substr(2, 9)}`;
  const inputClasses = [
    'input',
    error && 'input--error',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className="input-wrapper">
      {label && (
        <label htmlFor={inputId} className="input__label">
          {label}
          {required && <span className="input__required">*</span>}
        </label>
      )}
      <input
        id={inputId}
        type={type}
        className={inputClasses}
        placeholder={placeholder}
        required={required}
        {...props}
      />
      {error && (
        <span className="input__error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default Input;
